// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyC9HXz7R4Dl9fxBM4qslWJ1gabxhStmTTE",
    authDomain: "cercanosph.firebaseapp.com",
    projectId: "cercanosph",
    storageBucket: "cercanosph.appspot.com",
    messagingSenderId: "265874229654",
    appId: "1:265874229654:web:b11d7368a1e171cd3375b7",
    measurementId: "G-5NBHHGCMLY"
    }
  
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
